import React, { useEffect } from 'react';
import "./index.scss";
import AppTool from '@utils/app-tool';

const FindIdDialog = () => {

  const handleClose = () => {
    AppTool.closeDialog('.cFindIdDialog')
  };

  useEffect(() => {
  }, []);

  return (
    <div className="cFindIdDialog cDialogAttr" >
      <div className="cMask" onClick={() => { handleClose() }}></div>
      <div className="cDialog" >
        <div className="pc" >
          <img src={window.assetUrl('/images/voucher-page/pc/FindID.png')}></img>
        </div>
        <div className='mb'>
          <img src={window.assetUrl('/images/voucher-page/mobile/FindID-1.png')}></img>
          <img className='cFindIdText' src={window.assetUrl('/images/voucher-page/mobile/FindID-text.png')}></img>
          <div className='cFindID'>
            <div className='cImgContain'>
              <img src={window.assetUrl('/images/voucher-page/mobile/FindID-2.png')}></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FindIdDialog;